import React, { useState, useEffect } from "react";
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { ALL_ACCEPTED, ALL_REJECTED, getConsent, saveConsent } from '../Utils/cookieConsent';

function CookiesSetting() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  // Same store and categories as the footer consent dialog.
  const [preferences, setPreferences] = useState(ALL_REJECTED);

  useEffect(() => {
    const saved = getConsent();
    if (saved) setPreferences(saved);
  }, []);

  const savePrefs = (prefs) => {
    setPreferences(saveConsent(prefs));
  };

  return (
    <div className="r4l-cookie-settings">
      <h1>{t('footer.cookieSettings.title')}</h1>
      <p>{t('footer.cookieSettings.description')}</p>

      <div className="r4l-cookie-list">
        <label>
          <span>{t('footer.cookieSettings.essential')}</span>
          <small>{t('footer.cookieSettings.alwaysActive')}</small>
        </label>
        {['performance', 'functionality', 'marketing'].map((key) => (
          <label key={key}>
            <span>{t(`footer.cookieSettings.${key}`)}</span>
            <input
              type="checkbox"
              checked={Boolean(preferences[key])}
              onChange={(e) => setPreferences({ ...preferences, [key]: e.target.checked })}
            />
          </label>
        ))}
      </div>

      <div className="r4l-cookie-actions">
        <button type="button" className="r4l-btn-line" onClick={() => savePrefs(ALL_REJECTED)}>
          {t('footer.cookieSettings.rejectAll')}
        </button>
        <button type="button" className="r4l-btn-line" onClick={() => savePrefs(preferences)}>
          {t('footer.cookieSettings.savePreferences')}
        </button>
        <button type="button" className="r4l-btn" onClick={() => savePrefs(ALL_ACCEPTED)}>
          {t('footer.cookieSettings.acceptAll')}
        </button>
      </div>
    </div>
  );
}

export default CookiesSetting;
